import React from 'react';

const ErrorSignal = () => (
  <svg width="34px" height="34px" viewBox="0 0 34 34">
    <g id="Login" stroke="none">
      <g id="Sign-in---Error" transform="translate(-571.000000, -215.000000)" fill="#EF052C" fillRule="nonzero">
        <g id="Group-3" transform="translate(571.000000, 215.000000)">
          <path
            d="M17,8.5 C16.0611159,8.5 15.3,9.26111593 15.3,10.2 L15.3,17 C15.3,17.9388841 16.0611159,18.7 17,
            18.7 C17.9388841,18.7 18.7,17.9388841 18.7,17 L18.7,10.2 C18.7,9.26111593 17.9388841,8.5 17,8.5 Z M17,
            22.1 C16.0611159,22.1 15.3,22.8611159 15.3,23.8 C15.3,24.7388841 16.0611159,25.5 17,25.5 C17.9388841,
            25.5 18.7,24.7388841 18.7,23.8 C18.7,22.8611159 17.9388841,22.1 17,22.1 Z M33.507,9.452 L24.548,
            0.493 C24.2222226,0.182352665 23.7911039,0.00626193197 23.341,0 L10.659,0 C10.2088961,0.00626193197 9.77777744,
            0.182352665 9.452,0.493 L0.493,9.452 C0.182352665,9.77777744 0.00626193197,10.2088961 0,10.659 L0,
            23.341 C0.00626193197,23.7911039 0.182352665,24.2222226 0.493,24.548 L9.452,33.507 C9.77777744,
            33.8176473 10.2088961,33.9937381 10.659,34 L23.341,34 C23.7911039,33.9937381 24.2222226,33.8176473 24.548,
            33.507 L33.507,24.548 C33.8176473,24.2222226 33.9937381,23.7911039 34,23.341 L34,10.659 C33.9937381,
            10.2088961 33.8176473,9.77777744 33.507,9.452 Z M30.6,22.627 L22.627,30.6 L11.373,30.6 L3.4,22.627 L3.4,
            11.373 L11.373,3.4 L22.627,3.4 L30.6,11.373 L30.6,22.627 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ErrorSignal;
